export function echo<T>(input: T): T {
  return input;
}
